export default {
  title: 'Améliorez la fiabilité de votre indicateur',
  messageWarningRis:
    "Renseignez un relevé de situation individuelle (RSI) de moins d'un an pour augmenter la précision des informations ci-dessous ainsi que la pertinence de notre conseil.",
  button: 'Fiabiliser mes informations',
  uploadRisWarning:
    'Veuillez renseigner un nouveau relevé de situation individuelle pour mettre à jour votre carrière.',
}
